import { Component } from '@angular/core';

@Component({
    selector: 'carm-card-title',
    template: '<ng-content></ng-content>',
})
export class CardTitleComponent {}
